import { formatDisclaimerText } from './disclaimer.helper'
import styles from './disclaimer.module.scss'

const Disclaimer = (props: any) => {
  const product = 'bundle' in props ? props.bundle : props.product
  return (
    product?.disclaimer && (
      <div
        className={styles.disclaimerBox}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: formatDisclaimerText(product?.disclaimer) ?? '',
        }}
      />
    )
  )
}

export default Disclaimer
